import { __rest } from 'tslib';
import { SliderTypeEnum } from '@teko-builder/types/pb';

const convertOptionSliderV2ToV1 = (options) => {
    const { items, gridCols, gridRows, arrows, arrowStyle, pagination, paginationStyle, autoplay, pauseOnHover, rewind, paginationColor } = options, rest = __rest(options, ["items", "gridCols", "gridRows", "arrows", "arrowStyle", "pagination", "paginationStyle", "autoplay", "pauseOnHover", "rewind", "paginationColor"]);
    const newValue = Object.assign({ type: SliderTypeEnum.product, items, slidesPerColumn: gridRows, slidesPerView: gridCols, navigation: arrows || !!arrowStyle, navigationStyle: arrowStyle, pagination: pagination || !!paginationStyle, paginationStyle,
        autoplay, loop: rewind, pauseOnMouseEnter: pauseOnHover, paginationColor, virtual: gridRows === 1 }, rest);
    return Object.keys(newValue)
        .filter((el) => newValue[el] !== undefined)
        .reduce((acc, curr) => (Object.assign(Object.assign({}, acc), { [curr]: newValue[curr] })), {});
};

export { convertOptionSliderV2ToV1 as c };
